import React, { useEffect, useState, useCallback } from "react";
import { DashboardLayout } from "./DashboardLayout";
import { OrderDrawer } from "./OrderDrawer";
import { api, MXN, formatDateMX } from "../../lib/apiClient";
import { PAYMENT_STATUSES } from "../../lib/constants";
import { useAdminRealtime } from "../../hooks/useAdminRealtime";

export default function Pagos() {
  const [orders, setOrders] = useState([]);
  const [settings, setSettings] = useState({});
  const [filter, setFilter] = useState("");
  const [openId, setOpenId] = useState(null);

  const load = useCallback(() => {
    api.get("/orders", { params: filter ? { payment_status: filter } : {} }).then((r) => setOrders(r.data)).catch(() => {});
  }, [filter]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const id = setInterval(load, 15000);
    return () => clearInterval(id);
  }, [load]);
  useAdminRealtime(load, ["orders"]);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  const totalPend = orders.reduce((a, o) => a + Math.max(0, Number(o.final_price || 0) - (o.deposit || 0)), 0);

  return (
    <DashboardLayout title="Pagos">
      <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-3 mb-5 items-center">
        <select data-testid="pagos-filter" value={filter} onChange={(e) => setFilter(e.target.value)} className="w-full sm:w-auto bg-blancoCalido border-2 border-beige rounded-2xl sm:rounded-full px-4 py-3 text-sm focus:outline-none focus:border-vino">
          <option value="">Todos</option>
          {PAYMENT_STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
        <span className="text-sm text-cafe/60">Saldo por cobrar: <b className="text-vino">{MXN(totalPend)}</b></span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {orders.map((o) => {
          const paid = o.deposit || 0; const saldo = Number(o.final_price || 0) - paid;
          return (
            <button key={o.id} onClick={() => setOpenId(o.id)} data-testid={`pago-${o.id}`} className="w-full min-w-0 text-left bg-blancoCalido border border-beige rounded-[22px] p-5 shadow-pastel hover:-translate-y-1 transition-all">
              <div className="flex justify-between gap-2 min-w-0"><p className="font-medium text-vino truncate">{o.folio}</p><span className="shrink-0 text-xs px-2.5 py-1 rounded-full bg-beige text-vino">{PAYMENT_STATUSES.find((p) => p.value === o.payment_status)?.label}</span></div>
              <p className="text-sm text-cafe/70 mt-1">{o.customer_name}</p>
              <div className="grid grid-cols-1 min-[360px]:grid-cols-3 gap-2 mt-3 text-center text-xs">
                <div><p className="text-cafe/50">Total</p><p className="text-vino font-medium">{MXN(o.final_price)}</p></div>
                <div><p className="text-cafe/50">Pagado</p><p className="text-salvia font-medium">{MXN(paid)}</p></div>
                <div><p className="text-cafe/50">Saldo</p><p className="text-dorado font-medium">{MXN(saldo)}</p></div>
              </div>
            </button>
          );
        })}
      </div>
      {orders.length === 0 && <p className="text-cafe/50 text-sm">Sin registros.</p>}
      {openId && <OrderDrawer orderId={openId} settings={settings} onClose={() => setOpenId(null)} onUpdated={load} />}
    </DashboardLayout>
  );
}
